import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { GIFT_PRICE_LABEL } from "@/data/categories";
import { GiftRow } from "@/components/gift/GiftList";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });

export default function GiftDone() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [gift, setGift] = useState(null);
  const [tries, setTries] = useState(0);
  const code = params.get("code");
  const order = params.get("order");

  const load = () => api.get("/gifts/mine").then((r) => {
    const g = r.data.find((x) => (code && x.code === code) || (order && x.order_number === order));
    if (g) setGift(g); else setTries((t) => t + 1);
  });
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!gift && tries > 0 && tries < 6) { const t = setTimeout(load, 2000); return () => clearTimeout(t); }
  }, [tries, gift]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="gift-done-page" className="mx-auto max-w-3xl px-5 py-10 sm:px-6">
      <CheckCircle size={52} weight="duotone" className="text-[#4A8B6E]" />
      <h1 className="mt-3 font-serif text-4xl text-[#2D2824] sm:text-5xl">Thank you, your gift is ready</h1>
      {!gift && <p data-testid="gift-done-waiting" className="mt-4 text-[#6E665E]">{tries >= 6 ? "We're still confirming your payment. Your gift will appear on the Gift page shortly." : "Confirming your payment…"}</p>}
      {gift && (
        <>
          <section data-testid="gift-receipt" className="mt-6 rounded-2xl bg-white p-5 ring-1 ring-[#EBE4DA]">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#36858B]">Receipt</p>
            <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm text-[#4A4540]">
              <dt className="font-semibold">Product</dt><dd>Gift Lifetime Access</dd>
              <dt className="font-semibold">Amount</dt><dd data-testid="gift-receipt-amount"><span className="whitespace-nowrap">{GIFT_PRICE_LABEL}</span> · one time · No GST applies</dd>
              <dt className="font-semibold">Order</dt><dd data-testid="gift-receipt-order">{gift.order_number}</dd>
              <dt className="font-semibold">Date</dt><dd>{fmt(gift.created_at)}</dd>
              <dt className="font-semibold">Status</dt><dd>Paid</dd>
            </dl>
            <p className="mt-3 text-xs text-[#8A7F76]">A copy of this receipt has been emailed to {user?.email || "you"}.</p>
          </section>
          <section className="mt-6">
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#36858B]">Gift code, certificate and delivery</p>
            <ul><GiftRow g={gift} highlight onChanged={load} /></ul>
          </section>
        </>
      )}
      <button data-testid="gift-done-more" onClick={() => navigate("/gift")}
        className="mt-8 rounded-full border-2 border-[#E06D53] px-6 py-3 text-sm font-semibold text-[#E06D53] hover:bg-[#E06D53] hover:text-white">
        Give another gift
      </button>
    </div>
  );
}
